import { useMutation } from "@tanstack/react-query";
import { deactivateGoogleAds } from "../../api/bGoogleAdsApi";

export const useDeactivateGoogleAds = () => {
  return useMutation({
    mutationKey: ["deactivate-google-ads"],
    mutationFn: (data) => deactivateGoogleAds(data),
    onError: (error) => {
      console.error("Google Ads deactivation error:", error?.response || error);
    },
  });
};
